import React from 'react';
import { parse, format, asYouType, isValidNumber } from 'libphonenumber-js';

export const composeValidators = (...validators) => value =>
  validators.reduce((error, validator) => error || validator(value), undefined);

export const required = value => (value ? undefined : 'Required');
const maxLength = max => value =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined;
const maxLength15 = maxLength(15);
export const number = value => (value && isNaN(Number(value)) ? 'Must be a number' : undefined);
const minValue = min => value => (value && value < min ? `Must be at least ${min}` : undefined);
export const positiveNumber = minValue(0);

export const email = value => {
  if (value) {
    return !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
      ? 'Invalid email address'
      : undefined;
  }
  return undefined;
};

const tooOld = value => (value && value > 65 ? 'You might be too old for this' : undefined);

export const validRate = value => {
  if (value) {
    if (value > 9999.0) {
      return 'This rate seems a little high. Please enter a room rate per room and per night.';
    }
    if (value < 2) {
      return 'This rates seems a little low. Please enter a room rate per night.';
    }
    return undefined;
  }
  return 'Please enter a number.';
};

export const validPercentage = value => {
  if (value) {
    const numbers = value.match(/[0-9%.]/gi);
    if (numbers) {
      if (numbers.join('') === value) {
        if (value.includes('%')) {
          return 'Please do not include a percentage sign (%).';
        }
        if (parseFloat(value) > 100 || parseFloat(value) < 0) {
          return 'Please enter a valid percentage between 0 and 100.';
        }
        return undefined;
      }
    }
  }
  return 'Please enter a valid percentage.';
};

export const phoneNumber = value => {
  if (isValidNumber(value)) {
    return undefined;
  } else {
    return 'Invalid phone number, must be 15 digits';
  }
};

export const formatPhone = value => {
  return value;
};
export const normalizePhone = value => {
  if (Object.prototype.hasOwnProperty.call(value, 'value')) {
    return value.value.format();
  }
  if (Object.prototype.hasOwnProperty.call(value, 'format')) {
    return value.format();
  }
};

export const renderField = ({ input, label, type, meta: { touched, error, warning } }) => (
  <div>
    <label>{label}</label>
    <div>
      <input {...input} placeholder={label} type={type} />
      {touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}
    </div>
  </div>
);



// WEBPACK FOOTER //
// src/forms/index.js